var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 22,
    viewBox: "0 0 118 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2219_87163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9071 3.93352C33.3843 2.4212 35.2863 1.66504 37.6133 1.66504C39.9403 1.66504 41.8424 2.4212 43.3195 3.93352C44.7967 5.40551 45.5352 7.21021 45.5352 9.34762C45.5352 11.485 44.7967 13.2897 43.3195 14.7617C41.8222 16.2539 39.9201 17 37.6133 17C35.3066 17 33.4045 16.2539 31.9071 14.7617C30.43 13.2897 29.6914 11.485 29.6914 9.34762C29.6914 7.21021 30.43 5.40551 31.9071 3.93352ZM43.2892 9.34762C43.2892 7.73448 42.753 6.37339 41.6805 5.26436C40.6081 4.17549 39.2523 3.63105 37.6133 3.63105C35.9743 3.63105 34.6186 4.17549 33.5461 5.26436C32.4737 6.37339 31.9375 7.73448 31.9375 9.34762C31.9375 10.9406 32.4737 12.2916 33.5461 13.4006C34.6186 14.4895 35.9743 15.0339 37.6133 15.0339C39.2523 15.0339 40.6081 14.4895 41.6805 13.4006C42.753 12.2916 43.2892 10.9406 43.2892 9.34762Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1391 16.637H48.1787V15.1852L57.5272 3.93352H48.8161V2.028H60.6535V3.54032L51.3353 14.7315H61.1391V16.637Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9113 16.7277H69.908L63.1698 2.028H65.6284L70.9703 13.7938L76.282 2.028H78.6494L71.9113 16.7277Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9782 3.93352C84.4553 2.4212 86.3574 1.66504 88.6844 1.66504C91.0114 1.66504 92.9135 2.4212 94.3906 3.93352C95.8677 5.40551 96.6063 7.21021 96.6063 9.34762C96.6063 11.485 95.8677 13.2897 94.3906 14.7617C92.8932 16.2539 90.9911 17 88.6844 17C86.3776 17 84.4756 16.2539 82.9782 14.7617C81.501 13.2897 80.7625 11.485 80.7625 9.34762C80.7625 7.21021 81.501 5.40551 82.9782 3.93352ZM94.3602 9.34762C94.3602 7.73448 93.824 6.37339 92.7516 5.26436C91.6791 4.17549 90.3234 3.63105 88.6844 3.63105C87.0454 3.63105 85.6896 4.17549 84.6172 5.26436C83.5448 6.37339 83.0085 7.73448 83.0085 9.34762C83.0085 10.9406 83.5448 12.2916 84.6172 13.4006C85.6896 14.4895 87.0454 15.0339 88.6844 15.0339C90.3234 15.0339 91.6791 14.4895 92.7516 13.4006C93.824 12.2916 94.3602 10.9406 94.3602 9.34762Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.862 6.77668V16.637H100.676V2.028H102.862V4.26623C104.42 2.5321 106.372 1.66504 108.72 1.66504C110.521 1.66504 111.897 2.19939 112.848 3.2681C113.819 4.31664 114.304 5.80879 114.304 7.74456V16.637H112.119V8.22851C112.119 5.22403 110.733 3.72179 107.961 3.72179C106.949 3.72179 105.968 4.03434 105.017 4.65943C104.045 5.28452 103.327 5.99027 102.862 6.77668Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.975 8.86443C24.975 10.3969 24.7726 11.8689 24.3679 13.2804C23.943 14.6717 23.3967 15.811 22.7289 16.6982L20.2097 16.6982C20.9381 15.8513 21.5654 14.7524 22.0915 13.4014C22.6176 11.9496 22.8807 10.4877 22.8807 9.01566C22.8807 7.34203 22.5164 5.97086 21.788 4.90215C21.0595 3.83345 20.0883 3.29909 18.8742 3.29909C17.741 3.17811 16.7799 3.76287 15.9907 5.05338C15.7884 5.31552 15.586 5.73897 15.3837 6.32373L14.9284 7.65457C14.9082 7.71507 14.8778 7.83605 14.8373 8.01753C14.7766 8.19901 14.7159 8.40065 14.6552 8.62246C14.5743 8.8241 14.5035 9.03582 14.4428 9.25763C14.0785 10.5078 13.856 11.2539 13.775 11.4959C13.5524 12.1411 13.2995 12.7662 13.0162 13.3711C12.6925 14.0366 12.3383 14.5608 11.9539 14.944C11.0231 15.8312 9.86971 16.2748 8.49374 16.2748C6.89519 16.2748 5.57993 15.6295 4.54796 14.339C3.51599 13.0485 3 11.2539 3 8.95517C3 6.41447 3.58681 4.21657 4.76042 2.36146L7.06719 2.36146C5.75193 4.45854 5.0943 6.63628 5.0943 8.89467C5.0943 10.528 5.41806 11.7882 6.06557 12.6755C6.71308 13.5627 7.54271 14.0063 8.55444 14.0063C9.36384 14.1273 10.1631 13.6736 10.9523 12.6452C11.0939 12.4839 11.2558 12.1512 11.4379 11.6471L11.8325 10.6187L12.1967 9.31812L12.5609 8.04778C12.9049 6.93874 13.1275 6.24307 13.2287 5.96077C13.431 5.37601 13.7042 4.761 14.0482 4.11575C14.3922 3.45033 14.7766 2.90589 15.2016 2.48244C16.1121 1.49439 17.3262 1.00037 18.8438 1.00037C20.7459 1.00037 22.2433 1.76661 23.3359 3.29909C24.4286 4.81141 24.975 6.66652 24.975 8.86443Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2219_87163",
    x: 0,
    y: 0,
    width: 117.304,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2219_87163"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2219_87163",
    result: "effect2_dropShadow_2219_87163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2219_87163",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLogo);
export default __webpack_public_path__ + "static/media/video_logo.c4ae36ec3217fcd4d08177d514a499ea.svg";
export { ForwardRef as ReactComponent };